import type { SVGProps } from 'react';

export const TopicShelfIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' aria-hidden='true' {...props}>
    <path d='M3 4.5A2.5 2.5 0 0 1 5.5 2H11c.74 0 1.45.27 2 .76A3 3 0 0 1 15 2h3.5A2.5 2.5 0 0 1 21 4.5V19a1 1 0 0 1-1 1h-5a3 3 0 0 0-2.12.88L12 21.76l-.88-.88A3 3 0 0 0 9 20H4a1 1 0 0 1-1-1V4.5Zm8 13.82V5a1 1 0 0 0-1-1H5.5a.5.5 0 0 0-.5.5V18h4c.7 0 1.39.11 2 .32Zm2 0c.61-.21 1.3-.32 2-.32h4V4.5a.5.5 0 0 0-.5-.5H15a2 2 0 0 0-2 2v12.32Z' />
  </svg>
);
